import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { HiArrowSmLeft } from 'react-icons/hi';
import { Link } from 'react-router';
import { Button } from '@src/components';

interface Props {
  className?: string;
  previousUrl: string | null;
  onClick?: () => void;
  buttonType?: 'submit' | 'button';
  nextDisabled?: boolean;
  disabled?: boolean;
  nextText?: string;
}

function OrderNavigationButtons({
  className,
  previousUrl,
  onClick,
  buttonType = 'button',
  nextDisabled,
  disabled,
  nextText,
}: Props): JSX.Element {
  const { t } = useTranslation(['nif', 'translation']);
  return (
    <div className={clsx('flex items-center justify-between', className)}>
      {previousUrl ? (
        <Link
          to={previousUrl}
          className={clsx('flex', { 'pointer-events-none': disabled })}
        >
          <HiArrowSmLeft className="h-6 w-6 text-gray-900" />
          <div className="ml-2 text-gray-900">
            {t('buttons.back', 'Back', { ns: 'translation' })}
          </div>
        </Link>
      ) : (
        <div />
      )}

      <Button
        className="w-32 justify-center"
        disabled={disabled || nextDisabled}
        onClick={onClick}
        type={buttonType}
      >
        {nextText || t('buttons.next', 'Next', { ns: 'translation' })}
      </Button>
    </div>
  );
}

export default OrderNavigationButtons;
